// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__qy+UTHx2","warning":"SignUpIncorrectBirthStep_warning__aLEQA+Ti","back":"SignUpIncorrectBirthStep_back__6XgkyM+m"};